module.exports = __webpack_public_path__ + "static/media/35.faa38ada.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/35.jpg
// module id = 295
// module chunks = 0